<div class="">
    <div class="pad-L flex-align-center flex-space-between">
        <div class="disp-f a-i-c mr-s">
            <span class="font-MM fw-700">{{ 'page.dashboard.alerts' | translate }}</span>
            <div class="disp-f a-i-c j-c-c" style="height: 25px; width: 25px;"
                 [tooltip]="'page.announcement.list.tooltip'|translate" tooltipPosition="right">
                <img src="assets/icons/help-2.svg" width="14" height="14" alt=""/>
            </div>
        </div>
        <app-button-widget [disabled]="isReadonly" (onClick)="openCreateAnnouncement()" [tooltip]="'readOnly.buttonTooltip' | translate" [tooltipDisabled]="!isReadonly" tooltipPosition="left">
            <img *ngIf="!isReadonly" width="12" src="assets/icons/add.svg" class="filter-primary" alt="">
			<img *ngIf="isReadonly" width="15" src="assets/icons/lock-01.svg">
        </app-button-widget>
    </div>
	<div class="pad-0-L flex-column j-c-sb">
        <app-tabs>
            <app-tab title="{{ 'page.announcement.list.tab1' | translate }}"  [iconSrc]="'assets/icons/zap-black.svg'">
                <div class="container-list">
                    @if (activeAnnouncements.length > 0) {
                        <app-announcement-line
                                *ngFor="let announcement of activeAnnouncements; let first = first"
                                [announcement]="announcement"
								[readonly]="isReadonly"
                                [first]="first"
                                (deleted)="deleteAnnouncement($event)"
                                (open)="openAnnouncement($event)"
                        ></app-announcement-line>
                    } @else {
                        <div  class="flex-align-center flex-justify-center h-100" style="height:calc(100vh - 300px)">
                            <div class="w-100 flex-justify-center a-i-c f-d-col webkit-fill-available gap-XXL">
                                <img class="mr-xs" src="assets/illustrations/no_announcement.svg" [width]="200" alt="">
                                <div class="font-M fw-500">
                                    <span >{{ 'global.noAnnouncement' | translate }}</span>
                                </div>
                                <app-text-button *ngIf="!isReadonly" type="flat" (click)="openCreateAnnouncement()">
                                    <span class="fw-500">{{ 'global.addAnnouncement' | translate }}</span>
                                </app-text-button>
                            </div>
                        </div>
                    }
                </div>
            </app-tab>

            <app-tab title="{{'page.announcement.list.tab2' | translate }}" [chips]="programmedAnnouncements.length > 0 ? programmedAnnouncements.length.toString() : ''" [disabled]="programmedAnnouncements && programmedAnnouncements.length < 1" [iconSrc]="'assets/icons/alarm-clock-check.svg'">
                <app-announcement-line
                        *ngFor="let announcement of programmedAnnouncements; let first = first"
                        [announcement]="announcement"
						[readonly]="isReadonly"
						[first]="first"
                        (deleted)="deleteAnnouncement($event)"
                        (open)="openAnnouncement($event)"
                ></app-announcement-line>
            </app-tab>

            <app-tab title="{{ 'page.announcement.list.tab3' | translate }}"  [disabled]="archiveAnnouncements && archiveAnnouncements.length < 1" [iconSrc]="'assets/icons/clock-rewind.svg'">
                <app-announcement-line
                        *ngFor="let announcement of archiveAnnouncements; let first = first"
                        [announcement]="announcement"
						[readonly]="isReadonly"
						[first]="first"
                        (deleted)="deleteAnnouncement($event)"
                        (open)="openAnnouncement($event)"
                ></app-announcement-line>
            </app-tab>
        </app-tabs>
	</div>
</div>
